import React from "react";
import Image from "../../assets/Images/service-bg.jpg";

export default function Service() {
  return (
    <div class="page">
      <div className="row no-gutters row-layout">
        <div className="col-lg-5 col-layout2">
          <div className="column-info2">
            <h2>Professionals At Work.</h2>
            <p>
              Black Jade takes pride in our experience and professionalism when
              it comes to customer service.
            </p>
            <p>
              Styles we tattoo include (but not limited to): Oriental,
              Traditional Japanese, Black and Grey, Colour work, Realism,
              Traditional, Neo-traditional, Fine Line, Mandala/ Geometric
              Stippling, Botanical illustration, Blackwork, Custom Script, Trash
              Polka and Pop Culture inspired tattoos.
            </p>
          </div>
        </div>
        <div
          className="col-lg-7 col-layout"
          style={{ backgroundImage: `url(${Image})` }}
        >
          {/* <img src={Image} alt="Store front" className="col-image" /> */}
        </div>
      </div>
    </div>
  );
}
